import React, { useEffect } from 'react';
import '../styles/Services.css';
import { FaSearch, FaLanguage, FaShippingFast, FaClipboardCheck, FaHandshake } from 'react-icons/fa';

const Services = () => {
  useEffect(() => {
    const cards = document.querySelectorAll('.process-card');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card, index) => {
      card.style.transitionDelay = `${index * 0.3}s`; // delay for staggered animation
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="services-page">
      {/* Header Section */}
      <div className="services-header">
        <h1>Our Services</h1>
        <p className="services-subtitle">
          Seamless Trade Solutions Between Ethiopia and China
        </p>
        <p className="services-description">
          Explore our comprehensive international trade services focused on efficiency and client success.
        </p>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">
              <FaSearch />
            </div>
            <h3>Global Sourcing</h3>
            <p>We source high-quality products directly from manufacturers across China, ensuring the best prices and quality control.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <FaLanguage />
            </div>
            <h3>Language Support</h3>
            <p>Our team speaks Chinese, English, and Amharic to facilitate smooth communication and business transactions.</p>
          </div>

          <div className="service-card">
            <div className="service-icon">
              <FaShippingFast />
            </div>
            <h3>Reliable Shipping</h3>
            <p>We handle all logistics and ensure timely delivery to Ethiopia and other global destinations.</p>
          </div>
        </div>
      </div>

      {/* Process Section */}
      <div className="process-section">
        <div className="process-header">
          <h2>Our Process</h2>
          <p className="process-description">
            Discover how Dani Import and Export Trading streamlines your international trade journey from sourcing to delivery.
          </p>
        </div>

        <div className="process-grid">
          <div className="process-card">
            <div className="step-header">
              <div className="step-number">01</div>
              <div className="step-icon">
                <FaClipboardCheck />
              </div>
            </div>
            <h4>Product Sourcing</h4>
            <p>We begin by identifying reliable suppliers in China to provide quality products tailored to your business needs.</p>
          </div>

          <div className="process-card">
            <div className="step-header">
              <div className="step-number">02</div>
              <div className="step-icon">
                <FaShippingFast />
              </div>
            </div>
            <h4>Logistics Management</h4>
            <p>Our team coordinates transport and shipping, ensuring your goods move smoothly across borders with efficiency.</p>
          </div>

          <div className="process-card">
            <div className="step-header">
              <div className="step-number">03</div>
              <div className="step-icon">
                <FaHandshake />
              </div>
            </div>
            <h4>Customs & Quality Control</h4>
            <p>We handle customs clearance and perform thorough inspections to guarantee your shipments meet all standards.</p>
          </div>
        </div>

        <button className="learn-more-btn">Learn More</button>
      </div>
    </div>
  );
};

export default Services;
